import React, { useEffect, useState } from 'react'
import { Box, Stack, Typography } from '@mui/material';
import { Else, If, Then } from 'react-if';
import { useSelector } from 'react-redux';

const defaultSliderContent = [
    {
        imageIcon: "/img/svg/LeftImage.svg",
        title: "Best Employee Experience Platform",
        subTitle:
            "Don’t limit yourself. Many people limit themselves to what they think they can do. You can go as far as your mind lets you. You achieve what you believe.",
    },
    {
        imageIcon: "/img/svg/market_analysis.svg",
        title: "Finally a place where it all comes together",
        subTitle:
            "Employees like you can even make Mondays a joy. Thanks for your hard work and super attitude.",
    },
    {
        imageIcon: "/img/svg/designer.svg",
        title: "Focus on the work that matters",
        subTitle:
            "Business opportunities are like buses, there’s always another one coming.",
    },
];

const CustomSlider = ({ sliderArray = defaultSliderContent, orgWithCompleteLayout = false }) => {
    const [timer, setTimer] = useState(0);
    sliderArray = sliderArray?.length > 0 ? sliderArray : defaultSliderContent;
    const { loading } = useSelector((state) => state.common);

    useEffect(() => {
        const intervalId = setInterval(() => { setTimer((pre) => pre == sliderArray.length - 1 ? 0 : pre + 1) }, 3000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <If condition={loading}>
            <Then>

            </Then>
            <Else>
                <Stack flexDirection={'column'} bgcolor={'#031A2D'} width={'100%'} height={'100%'} padding={orgWithCompleteLayout ? 0 : 10} overflow={'hidden'}>
                    <Box flex={1}>
                        <If condition={orgWithCompleteLayout}>
                            <Then>
                                <img
                                    src={sliderArray[timer].imageIcon}
                                    style={{ height: "100%", width: "100%" }}
                                    alt={sliderArray[timer].title}
                                />
                            </Then>
                            <Else>
                                <img
                                    src={sliderArray[timer].imageIcon}
                                    style={{ height: "auto", maxWidth: "100%" }}
                                    alt={sliderArray[timer].title}
                                />
                            </Else>
                        </If>

                        <Typography
                            variant="subtitle1"
                            sx={{ color: "#ffff", fontSize: "2.75rem", mt: 2, fontWeight: 'bolder' }}
                        >
                            {sliderArray[timer].title}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ color: "#ffff", fontSize: "1.125rem", mt: 2 }}
                        >
                            {sliderArray[timer].subTitle}
                        </Typography>
                    </Box>
                    <If condition={!orgWithCompleteLayout}>
                        <Then>
                            <Stack flexDirection={'row'} gap={2}>
                                {sliderArray.map((_, index) => <span key={index} style={{ width: index == timer ? '50px' : '20px', height: '2px', backgroundColor: index == timer ? 'blue' : 'white', borderRadius: '3px' }} />)}
                            </Stack>
                        </Then>
                    </If>
                </Stack>
            </Else>
        </If>
    )
}

export default CustomSlider;